var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPentagonConstruction(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 154,
    height: 134,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M152.27 67l-37.638 65.5H39.368L1.73 67 39.368 1.5h75.264L152.27 67z",
    stroke: "#E0621E",
    strokeWidth: 3
  })));
}
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTU0IiBoZWlnaHQ9IjEzNCIgdmlld0JveD0iMCAwIDE1NCAxMzQiIGZpbGw9Im5vbmUiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICA8cGF0aCBkPSJNMTUyLjI3IDY3TDExNC42MzIgMTMyLjVIMzkuMzY4MUwxLjczMDAxIDY3TDM5LjM2ODEgMS41SDExNC42MzJMMTUyLjI3IDY3WiIgc3Ryb2tlPSIjRTA2MjFFIiBzdHJva2Utd2lkdGg9IjMiLz4KPC9zdmc+Cg==";
export { SvgPentagonConstruction as ReactComponent };